import React, { useEffect } from "react";
import "./styles/App.css";
import Router from "./router/Router.js";
import "react-toastify/dist/ReactToastify.css";
import { loadSeller, loadUser } from "./redux/actions/user";
import { useLogedIn } from "./hooks/useLogedIn";
import { getAllEvents } from "./redux/actions/event";
import { getAllProducts } from "./redux/actions/product";
import { useDispatch } from "react-redux";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUser());
    dispatch(loadSeller());
    dispatch(getAllEvents());
    dispatch(getAllProducts());
  }, [dispatch]);

  useLogedIn();

  return <Router />;
};

export default App;
